export const CvActionTypes = {
  LOADING_LIST_CV: 'LOADING_LIST_CV',
  LOADING_CREATE_CV: 'LOADING_CREATE_CV',
  LOADING_UPDATE: 'LOADING_UPDATE',
  CREATE_CV_START: 'CREATE_CV_START',
  CREATE_CV_FINISH: 'CREATE_CV_FINISH',
  CREATE_CV_FAILURE: 'CREATE_CV_FAILURE',
  DELETE_CV_START: 'DELETE_CV_START',
  DELETE_CV_FINISH: 'DELETE_CV_FINISH',
  DELETE_CV_FAILURE: 'DELETE_CV_FAILURE',
  LOAD_CV_START: 'LOAD_CV_START',
  LOAD_CV_FINISH: 'LOAD_CV_FINISH',
  UPDATE_CV_START: 'UPDATE_CV_START',
  UPDATE_CV_FINISH: 'UPDATE_CV_FINISH',
  UPDATE_CV_FAILURE: 'UPDATE_CV_FAILURE',
  LOAD_CV_FAILURE: 'LOAD_CV_FAILURE',
  LOAD_LIST_CV_START: 'LOAD_LIST_CV_START',
  LOAD_LIST_CV_FINISH: 'LOAD_LIST_CV_FINISH',
  LOAD_LIST_CV_FAILURE: 'LOAD_LIST_CV_FAILURE',
  UPLOAD_CV_IMAGE_START: 'UPLOAD_CV_IMAGE_START',
  UPLOAD_CV_IMAGE_END: 'UPLOAD_CV_IMAGE_END',
  UPLOAD_CV_IMAGE_FAILURE: 'UPLOAD_CV_IMAGE_FAILURE',
};
